module.exports = __webpack_public_path__ + "img/mp_success.e19b2c49.png";